import React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { DropDownList } from '@progress/kendo-react-dropdowns';

const hasValue = value => value !== undefined && value !== null;

const BooleanCellFilter = (props) => {
    const { filterValue, setFilterValue } = props;

    const onChange = (event) => {
        setFilterValue(event.value);

        props.onChange({
            value:          event.value === props.defaultItem ? '' : event.value.value,
            operator:       event.value === props.defaultItem ? '' : 'eq',
            field:          props.field,
            syntheticEvent: event.syntheticEvent
        });
    };

    const onClearButtonClick = event => {
        event.preventDefault();
        setFilterValue(props.defaultItem);
        props.onChange({
            value:          '',
            operator:       '',
            field:          props.field,
            syntheticEvent: event,
        });
    };

    const hasVal = hasValue(props.value);

    return (
        <div className="k-filtercell">
            <DropDownList
                data={props.data}
                onChange={onChange}
                textField={'text'}
                dataItemKey={'value'}
                value={
                    hasVal
                        ? props.data.find((d) => d.value === props.value)
                        : { ...filterValue }
                }
                defaultItem={props.defaultItem}
            />
            <Button
                title="Clear"
                disabled={!hasVal}
                onClick={onClearButtonClick}
                icon="filter-clear"
                style={{marginLeft: '3px'}}
            />
        </div>
    );
};
export default (BooleanCellFilter);
